import { gql } from '@apollo/client';

export const AUTOCOMPLETE_ES_PRODUCTS = gql`
  query autocompleteEsProducts($autocompleteFilter: AutocompleteFilter!) {
    autocompleteEsProducts(autocompleteFilter: $autocompleteFilter) {
      data {
        id
        value
      }
    }
  }
`;

export const FILTER_ES_PRODUCTS = gql`
  query filterEsProducts($searchFilter: SearchFilter!) {
    filterEsProducts(searchFilter: $searchFilter) {
      meta {
        total
        lastPage
        currentPage
        perPage
        prev
        next
      }
      data {
        productId
        subProductId
        productFullDescription
        productShortDescription
        barcodeNumber
        exitPackaging
        sectionId
        sectionDescription
      }
    }
  }
`;

export const FIND_PRODUCTS_BY_FILTER = gql`
  query FindProductsByFilter(
    $filialId: Int!
    $filter: String!
    $page: Int!
    $limit: Int!
  ) {
    FindProductsByFilter(
      filialId: $filialId
      filter: $filter
      page: $page
      limit: $limit
    ) {
      meta {
        total
        lastPage
        currentPage
        perPage
        prev
        next
      }
      data {
        ean
        galleries {
          imageId
          placeholder
        }
        productfilials {
          code
          resume
          description
          incomingPackaging
          exitPackaging
          galleries {
            imageId
            placeholder
          }
          prices {
            saleType
            regularPrice
            promotionalPrice
          }
        }
      }
    }
  }
`;

export const AUTOCOMPLETE_PROMOTIONAL_PRODUCTS = gql`
  query autocompletePromotionalProducts(
    $filialIds: [Int!]!
    $autocompleteFilter: AutocompleteFilter!
  ) {
    autocompletePromotionalProducts(
      filialIds: $filialIds
      autocompleteFilter: $autocompleteFilter
    )
  }
`;

export const AUTOCOMPLETE_OFFLINE_PRODUCTS = gql`
  query autocompleteOfflineProducts(
    $filialIds: [Int!]!
    $autocompleteFilter: AutocompleteFilter!
  ) {
    autocompleteOfflineProducts(
      filialIds: $filialIds
      autocompleteFilter: $autocompleteFilter
    )
  }
`;

export const FIND_PRODUCT = gql`
  query findProduct($findProductInput: FindProductInput!) {
    findProduct(findProductInput: $findProductInput) {
      id
      ean
      resume
      description
      galleries {
        id
        imageId
        isThumbnail
        placeholder
        createdAt
        updatedAt
      }
      productfilials {
        id
        code
        resume
        description
        exitPackaging
        incomingPackaging
        prices {
          id
          saleType
          regularPrice
          promotionalPrice
          promotionalStartDate
          promotionalEndDate
        }
        galleries {
          id
          imageId
          isThumbnail
          placeholder
          createdAt
          updatedAt
        }
        promotionalProducts {
          id
          maxQuantity
          minQuantity
          promotionalPrice
          promotion {
            id
            type
            description
            startDate
            endDate
            createdAt
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const FIND_FILTERED_PROMOTIONAL_PRODUCTS = gql`
  query findFilteredPromotionalProducts(
    $filialIds: [Int!]!
    $searchFilter: SearchFilter!
  ) {
    findFilteredPromotionalProducts(
      filialIds: $filialIds
      searchFilter: $searchFilter
    ) {
      meta {
        total
        lastPage
        currentPage
        perPage
        prev
        next
      }
      data {
        id
        promotionalProductId
        ean
        description
        resume
        code
        filial
        incomingPackaging
        exitPackaging
        price {
          regularPrice
          promotionalPrice
          promotionalStartDate
          promotionalEndDate
        }
        promotion {
          type
          description
          promotionalPrice
          promotionalStartDate
          promotionalEndDate
        }
      }
    }
  }
`;

export const FIND_FILTERED_OFFLINE_PRODUCTS = gql`
  query findFilteredOfflineProducts(
    $filialIds: [Int!]!
    $searchFilter: SearchFilter!
  ) {
    findFilteredOfflineProducts(
      filialIds: $filialIds
      searchFilter: $searchFilter
    ) {
      meta {
        total
        lastPage
        currentPage
        perPage
        prev
        next
      }
      data {
        id
        ean
        description
        resume
        code
        filial
        incomingPackaging
        exitPackaging
        price {
          regularPrice
          promotionalPrice
          promotionalStartDate
          promotionalEndDate
        }
        offlinePrice {
          regularPrice
          promotionalPrice
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const FIND_FILTERED_PRODUCTS = gql`
  query findFilteredProducts(
    $filialIds: [Int!]!
    $searchFilter: SearchFilter!
  ) {
    findFilteredProducts(filialIds: $filialIds, searchFilter: $searchFilter) {
      meta {
        total
        lastPage
        currentPage
        perPage
        prev
        next
      }
      data {
        id
        ean
        description
        resume
        code
        filial
        incomingPackaging
        exitPackaging
        price {
          regularPrice
          promotionalPrice
          promotionalStartDate
          promotionalEndDate
        }
      }
    }
  }
`;
